<div class="sw-cms-block-moorl-grid-layout-twelve">
    <slot name="slot-a"></slot>
    <slot name="slot-b"></slot>
    <slot name="slot-c"></slot>
    <slot name="slot-d"></slot>
    <slot name="slot-e"></slot>
</div>